/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Login_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_email_placeholder = /** @type {((inputs?: Login_Email_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre email")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Ihre E-Mail-Adresse ein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите свой адрес электронной почты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduce tu correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入您的电子邮件地址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना ईमेल दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira seu e-mail")
	return /** @type {LocalizedString} */ ("Enter your email")
});